import AccountPage from '@/views/AccountPage.vue'
import ApiDebugPage from '@/views/ApiDebugPage.vue'
import BalanceTaskDetailPage from '@/views/BalanceTaskDetailPage.vue'
import BalanceTaskPage from '@/views/BalanceTaskPage.vue'
import CustomerBalanceDetailPage from '@/views/customer/CustomerBalanceDetailPage.vue'
import CustomerDetailPage from '@/views/customer/CustomerDetailPage.vue'
import CustomerPage from '@/views/customer/CustomerPage.vue'
import MerchantPage from '@/views/MerchantPage.vue'
import NotFoundPage from '@/views/NotFoundPage.vue'
import PaymentChannelDetailPage from '@/views/payment-channel/PaymentChannelDetailPage.vue'
import PaymentChannelPage from '@/views/payment-channel/PaymentChannelPage.vue'
import PaymentOrderDetailPage from '@/views/PaymentOrderDetailPage.vue'
import PaymentOrderPage from '@/views/PaymentOrderPage.vue'
import PriceTablePage from '@/views/PriceTablePage.vue'
import EquityDetailPage from '@/views/product/EquityDetailPage.vue'
import EquityPage from '@/views/product/EquityPage.vue'
import PaywallDetailPage from '@/views/product/PaywallDetailPage.vue'
import ProductDetailPage from '@/views/product/ProductDetailPage.vue'
import ProductPage from '@/views/product/ProductPage.vue'
import ProjectDetailPage from '@/views/ProjectDetailPage.vue'
import PromoterConfigPage from '@/views/promoter/PromoterConfigPage.vue'
import PromoterCustomerListPage from '@/views/promoter/PromoterCustomerListPage.vue'
import PromoterDetailPage from '@/views/promoter/PromoterDetailPage.vue'
import PromoterListPage from '@/views/promoter/PromoterListPage.vue'
import PromoterPayoutListPage from '@/views/promoter/PromoterPayoutListPage.vue'
import PromoterPayoutPage from '@/views/promoter/PromoterPayoutPage.vue'
import PromoterProfitListPage from '@/views/promoter/PromoterProfitListPage.vue'
import RedeemCodeDetailPage from '@/views/RedeemCodeDetailPage.vue'
import RedeemCodePage from '@/views/RedeemCodePage.vue'
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/dash/',
  },
  {
    path: '/dash/',
    name: MerchantPage.name,
    component: MerchantPage,
  },
  {
    path: '/dash/account',
    name: AccountPage.name,
    component: AccountPage,
  },
  {
    path: '/dash/project-detail',
    name: ProjectDetailPage.name,
    component: ProjectDetailPage,
  },
  {
    path: '/dash/api-debug',
    name: ApiDebugPage.name,
    component: ApiDebugPage,
  },
  {
    path: '/dash/payment-channel',
    name: PaymentChannelPage.name,
    component: PaymentChannelPage,
  },
  {
    path: '/dash/payment-channel-detail',
    name: PaymentChannelDetailPage.name,
    component: PaymentChannelDetailPage,
  },
  {
    path: '/dash/price-table',
    name: PriceTablePage.name,
    component: PriceTablePage,
  },
  {
    path: '/dash/product',
    name: ProductPage.name,
    component: ProductPage,
  },
  {
    path: '/dash/equity',
    name: EquityPage.name,
    component: EquityPage,
  },
  {
    path: '/dash/equity-detail',
    name: EquityDetailPage.name,
    component: EquityDetailPage,
  },
  {
    path: '/dash/product-detail',
    name: ProductDetailPage.name,
    component: ProductDetailPage,
  },
  {
    path: '/dash/paywall-detail',
    name: PaywallDetailPage.name,
    component: PaywallDetailPage,
  },
  {
    path: '/dash/payment-order',
    name: PaymentOrderPage.name,
    component: PaymentOrderPage,
  },
  {
    path: '/dash/payment-order-detail',
    name: PaymentOrderDetailPage.name,
    component: PaymentOrderDetailPage,
  },
  {
    path: '/dash/customer',
    name: CustomerPage.name,
    component: CustomerPage,
  },
  {
    path: '/dash/customer-detail',
    name: CustomerDetailPage.name,
    component: CustomerDetailPage,
  },
  {
    path: '/dash/customer-balance-detail',
    name: CustomerBalanceDetailPage.name,
    component: CustomerBalanceDetailPage,
  },
  {
    path: '/dash/redeem-code',
    name: RedeemCodePage.name,
    component: RedeemCodePage,
  },
  {
    path: '/dash/redeem-code-detail',
    name: RedeemCodeDetailPage.name,
    component: RedeemCodeDetailPage,
  },
  {
    path: '/dash/balance-task',
    name: BalanceTaskPage.name,
    component: BalanceTaskPage,
  },
  {
    path: '/dash/balance-task-detail',
    name: BalanceTaskDetailPage.name,
    component: BalanceTaskDetailPage,
  },
  {
    path: '/dash/promoter-list',
    name: PromoterListPage.name,
    component: PromoterListPage,
  },
  {
    path: '/dash/promoter-detail',
    name: PromoterDetailPage.name,
    component: PromoterDetailPage,
  },
  {
    path: '/dash/promoter-payout-list',
    name: PromoterPayoutListPage.name,
    component: PromoterPayoutListPage,
  },
  {
    path: '/dash/promoter-payout',
    name: PromoterPayoutPage.name,
    component: PromoterPayoutPage,
  },
  {
    path: '/dash/promoter-profit-list',
    name: PromoterProfitListPage.name,
    component: PromoterProfitListPage,
  },
  {
    path: '/dash/promoter-customer-list',
    name: PromoterCustomerListPage.name,
    component: PromoterCustomerListPage,
  },
  {
    path: '/dash/promoter-config',
    name: PromoterConfigPage.name,
    component: PromoterConfigPage,
  },
  {
    path: '*',
    name: NotFoundPage.name,
    component: NotFoundPage,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
